<template>
  <v-dialog v-model="interf" :toShow.sync="toShow" scrollable persistent full-width max-width='933'>
    <v-card>
      <v-card-title>
        <v-flex>
          <span class="titulo-detalhes pl-12  mt-12 mb-12 headline">Manual CondoPlaza</span>
        </v-flex>
        <v-spacer></v-spacer>      
        <v-flex class="text-xs-right">
          <v-btn icon @click="closeManual">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-card-title>
        <v-card-text class="pa-0">
          <v-layout row wrap class="pl-12 pr-12" style="background-color:#f5f5f5" v-show="true">              
           <object style="min-height: 600px;" v-bind:data="urlPdf" width="100%" height="100%" type="application/pdf">
              <embed v-bind:src="urlPdf"  type="application/pdf" />
           </object>                        
         </v-layout>      
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'manual',
  props: {
    toShow: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data: function () {
    return {
      urlPdf: ''
    }
  },
  computed: {
    interf: {
      get () {
        return this.toShow
      },
      set (val) {
        this.$emit('toShow', val)
      }
    }
  },
  watch: {
    toShow (v) {
    }
  },
  methods: {
    closeManual () {
      this.$emit('update:toShow', false)
    }
  },
  created () {
    let uri = window.location.protocol + '//' + window.location.host
    if (uri.split('local').length > 1) {
      uri = 'http://localhost:58515/'
    }
    this.urlPdf = uri + '/Arquivos/Manual/help.pdf'
  }
}
</script>
<style>
.prefix.input-group--prefix:not(.input-group--focused):not(.input-group--dirty) label{
  left: 23px!important;
}
.item-box{
  border: 1px solid #bdbdbd;
  border-radius: 15px;
  float: left;
}
.item-imagem{
  width: 60px;
  float: left;
}
.item-detalhes{
  float: left;
  width: calc(100% - 60px);
  width: -moz-calc(100% - 60px);
}
.item-imagem img{
  height: 50px;
  width: 50px;
  border-radius: 100%;
  margin-right: 10px;
}
.item-detalhes .item-titulo{
  font-size: 20px;
  margin-bottom: 0px;
}

.item-preco, .item-rodape, .item-cabecalho{
  float: left;
  width: 100%;
}
.price-value-align-right {
  text-align: right!important;
}
.price-table-error {
  border: 1.5px solid red;
}
/*.price-box{
  border: 1px solid #d9d9d9;
  border-radius: 15px;
  padding: 20px;
  float: left;
  width: 100%;
  position: relative;
}*/
/*.price-box input{
  position: absolute;
  outline: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  padding-left: 37px;
  font-size: 22px;
  color: #5a5a5a;
}*/
/* ajustes */
.titulo-detalhes{
    color: #e62039;
    font-size: 21px;
}
.titulo-detalhes .headline{
  font-size: 25px;
}
.titulo-detalhes-categoria{
  font-size: 21px;
  padding-top: 17px;
  color: #707983
}
p{
color: #838789
}
</style>



// WEBPACK FOOTER //
// manual.vue?551581c2